import { Logger, type LogEntry } from '../utils/logger';

export class Terminal {
  private logger = new Logger();
  private unsubscribers: (() => void)[] = [];

  constructor(private container: HTMLElement) {
    this.unsubscribers.push(
      this.logger.subscribe((entry) => this.renderEntry(entry)),
    );
  }

  log(message: string, type: 'tx' | 'rx' | 'system' | 'error' | 'warn' = 'system'): void {
    this.logger.log(message, type);
  }

  clear(): void {
    this.logger.clear();
    this.container.innerHTML = '';
  }

  private renderEntry(entry: LogEntry): void {
    const entryDiv = document.createElement('div');
    entryDiv.className = 'log-entry';

    const timeSpan = document.createElement('span');
    timeSpan.className = 'log-time';
    timeSpan.innerText = `[${entry.timestamp.toLocaleTimeString()}]`;

    const msgSpan = document.createElement('span');
    msgSpan.className = `log-${entry.type}`;
    msgSpan.innerText = ` ${entry.message}`;

    entryDiv.appendChild(timeSpan);
    entryDiv.appendChild(msgSpan);

    this.container.appendChild(entryDiv);
    this.container.scrollTop = this.container.scrollHeight;
  }

  destroy(): void {
    this.unsubscribers.forEach((fn) => fn());
    this.unsubscribers = [];
  }
}
